export default __webpack_public_path__ + "static/media/Hofman.78615754.png";